import { FunctionComponent, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { QueryName } from "../modules/router/constantes/queryName";

export const LoginPage: FunctionComponent = () => {
  const { search } = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(search);
    let nextRoute = query.get(QueryName.nextRoute);
    if (nextRoute === null) {
      nextRoute = "";
    }
    window.open(`/api/login?${QueryName.nextRoute}=${encodeURIComponent(nextRoute)}`, "_self");
  }, [search]);

  return null;
};
